import { render, staticRenderFns } from "./invitation.vue?vue&type=template&id=6f9d1e05&scoped=true&"
import script from "./invitation.vue?vue&type=script&lang=js&"
export * from "./invitation.vue?vue&type=script&lang=js&"
import style0 from "./invitation.vue?vue&type=style&index=0&id=6f9d1e05&lang=scss&scoped=true&"
import style1 from "./invitation.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9d1e05",
  null
  
)

export default component.exports